import React, { useState } from "react";
import { Wrench, ChevronDown, ChevronUp } from "lucide-react";
import { COLOR } from "./pillars/_cards";
import { matchTsbs } from "../../lib/tsbData";
import { LvReplacementForm } from "./LvReplacementForm";
import { is16vModel } from "./LowVoltageCard";

export const TsbMatchCard = ({ vehicle }) => {
  const [open, setOpen] = useState(false);
  const items = matchTsbs(vehicle?.model, vehicle?.year);
  const vin = vehicle?.vin && !String(vehicle.vin).includes("•") ? String(vehicle.vin).toUpperCase() : null;
  if (items.length === 0) return null;

  return (
    <div
      className="rounded-xl border p-4"
      style={{ borderColor: "rgba(255,176,32,0.25)", background: "rgba(255,176,32,0.03)" }}
      data-testid="tsb-match-card"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-3 text-left"
        data-testid="tsb-toggle"
      >
        <div
          className="w-9 h-9 rounded-lg flex items-center justify-center border shrink-0"
          style={{ background: `${COLOR.amber}14`, borderColor: `${COLOR.amber}45` }}
        >
          <Wrench className="w-4 h-4" style={{ color: COLOR.amber }} strokeWidth={2.4} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-zinc-500">
            Known service bulletins
          </div>
          <div className="text-sm text-white font-semibold leading-snug">
            {items.length} known {items.length === 1 ? "item" : "items"} for your {vehicle?.year} {vehicle?.model}
          </div>
        </div>
        <span
          className="shrink-0 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-wider"
          style={{ color: COLOR.amber }}
        >
          {open ? "Hide" : "View"}
          {open ? <ChevronUp className="w-3.5 h-3.5" strokeWidth={2.4} /> : <ChevronDown className="w-3.5 h-3.5" strokeWidth={2.4} />}
        </span>
      </button>

      {open && (
        <div className="mt-3 pt-3 border-t border-white/5 space-y-3">
          {items.map((t, i) => (
            <div key={i} className="flex items-start gap-2.5" data-testid={`tsb-item-${i}`}>
              <span
                className="shrink-0 font-mono text-[8px] uppercase tracking-wider px-1.5 py-0.5 rounded mt-0.5"
                style={{ background: `${COLOR.cyan}14`, color: COLOR.cyan }}
              >
                {t.system}
              </span>
              <div className="min-w-0 flex-1">
                <div className="text-[12px] text-white font-semibold leading-tight">{t.title}</div>
                <div className="font-mono text-[10px] text-zinc-400 leading-relaxed mt-0.5">{t.note}</div>
          {t.id === "lv_battery" && (
            <LvReplacementForm
              vin={vin}
              sixteenV={is16vModel(vehicle?.model)}
              liIonLabel={is16vModel(vehicle?.model) ? "Lithium-ion 16V" : "Lithium-ion 12V"}
            />
          )}
              </div>
            </div>
          ))}
          <p className="font-mono text-[9px] text-zinc-500 leading-relaxed pt-1 border-t border-white/5">
            Curated from public service records &amp; owner reports — not an official
            Tesla list. Mention applicable items at your next service visit; many are
            covered under warranty or goodwill.
          </p>
        </div>
      )}
    </div>
  );
};
